import { render, staticRenderFns } from "./EditIABFDancer.vue?vue&type=template&id=1b33a043&scoped=true"
import script from "./EditIABFDancer.vue?vue&type=script&lang=js"
export * from "./EditIABFDancer.vue?vue&type=script&lang=js"
import style0 from "./EditIABFDancer.vue?vue&type=style&index=0&id=1b33a043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b33a043",
  null
  
)

export default component.exports